@if (unit && !disableUnit) {
  <div class="unit">
    <tt-form-field>
      <label for="speciality" ttLabel>{{ 'Unit' | transloco }}:</label>
      <tt-select [selected]="seletedUnit().id" (selectionChanged)="onMolarUnitSelect($event)">
        <tt-select-items>
          @for (availableUnit of availableUnits(); track availableUnit.id) {
            <tt-option [value]="availableUnit.id">{{ availableUnit.name }}</tt-option>
          }
        </tt-select-items>
      </tt-select>
    </tt-form-field>
  </div>
}

@if (disableUnit) {
  <div class="unit">
    <label for="sidebar-component--unit">{{ 'Unit' | transloco }}:</label>
    <input disabled id="sidebar-component--molarMass" type="text" [value]="unit?.name" />
  </div>
}

@if (molarMass) {
  <div class="molar-mass">
    <label for="sidebar-component--molarMass">{{ 'MolarMass' | transloco }} (g/mol):</label>
    <input disabled id="sidebar-component--molarMass" type="text" [value]="molarMass" />
  </div>
}
